import { constants, typographyStyles } from "@newsela/angelou";
const spacing = "0.5rem";
const greyDark = constants.colors.ui.neutral[600];
const coreBlue = constants.colors.ui.core[500];
const { heading3Obj, heading5Obj } = typographyStyles;
const neutral700 = constants.colors.ui.neutral[700];
const greyExtraLight = constants.colors.ui.neutral[25];

export const checkboxStyles = {
  "*": {
    boxSizing: "content-box",
  },
};

export const activitylistItemCss = [
  typographyStyles.textXSObj,
  {
    color: neutral700,
    display: "flex",
  },
];

export const activityListContainerCss = {
  display: "flex",
  flexFlow: "column",
  padding: "0",
  backgroundColor: greyExtraLight,
  marginBottom: "1rem",
};

export const addActivityButtonCss = {
  textDecoration: "underline",
  "&:hover:not([disabled])::before": {
    backgroundColor: "transparent",
  },
  "&:focus-visible:not([disabled])::before": {
    backgroundColor: "transparent",
  },
};

export const modalTitleCss = [heading3Obj];

export const modalFooterCss = {
  height: "18%",
};

export const modalFooterButtonRowCss = {
  display: "flex",
  flexFlow: "row nowrap",
  marginLeft: "auto",
  justifyContent: "flex-end",
  alignItems: "center",
  ">*": {
    marginLeft: spacing,
  },
};

export const headerSectionCss = {
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "space-between",
  margin: "1rem 0",
};

export const titleSectionCss = [
  {
    color: greyDark,
    margin: "0 1rem 0 0 !important",
    lineHeight: "22px",
  },
  heading5Obj,
];

export const viewActivitiesLinkCss = {
  padding: "0",
  textDecoration: "none",
};

export const customActivitiesCss = {
  marginTop: "1rem",
};

export const addIconCss = {
  height: "24px",
  width: "24px",
};

export const addActivityCard = {
  height: "242px",
  border: `1px dashed ${coreBlue}`,
  borderRadius: "4px",
  display: "flex",
  justifyContent: "center",
};
